<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="发布编号">
              <a-input placeholder="请输入发布编号" v-model="queryParam.publishCode"></a-input>
            </a-form-item>
          </a-col>
         <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="商品信息">
              <j-search-select-tag placeholder="请选择商品信息" v-model="queryParam.productInfo" dict="manufacture_product,prod_name,id"/>
            </a-form-item>
          </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="商品发布名称">
                <a-input placeholder="请输入商品发布名称" v-model="queryParam.publishProdName"></a-input>
              </a-form-item>
            </a-col>
          <!--  <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="商品发布简介">
                <a-input placeholder="请输入商品发布简介" v-model="queryParam.publishProdDescription"></a-input>
              </a-form-item>
            </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="所属门店">
                <j-dict-select-tag placeholder="请选择所属门店" v-model="queryParam.storeId" dictCode="sales_physical_store,phystore_name,id"/>
              </a-form-item>
            </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="是否可配送">
                <j-dict-select-tag placeholder="请选择是否可配送" v-model="queryParam.publishIsdelivery" dictCode="yesorno"/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="发布渠道">
                <j-multi-select-tag placeholder="请选择发布渠道" dictCode="sales_channel,channel_name,id" v-model="queryParam.publishChannel"/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="发布状态">
                <j-dict-select-tag placeholder="请选择发布状态" v-model="queryParam.publishState" dictCode="s_publish_state"/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="发布时间">
                <j-date placeholder="请选择发布时间" v-model="queryParam.publishTime"></j-date>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('商品发布台账')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0 ">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>批量删除</a-menu-item>
          <a-menu-item key="2" @click="handleBatchPublish"><a-icon type="home"/>批量发布</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <a slot="FormNoLink" @click="myHandleDetail(record)" slot-scope="text, record">{{text}}</a>

        <span slot="action" slot-scope="text, record">
          <a @click="myHandleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="publishProd(record)">发布</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                  <a @click="copyAndEdit(record)">复制</a>
              </a-menu-item>
              <a-menu-item v-if="record.publishState == 'publish_success'">
                  <a @click="handleUpdateStock(record)">更新库存</a>
              </a-menu-item>
              <a-menu-item v-if="record.publishState == 'publish_success'">
                <a-popconfirm title="确定上架吗?" @confirm="() => handlePutOnSale(record.id)">
                  <a>上架</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.publishState == 'publish_success'">
                <a-popconfirm title="确定下架吗?" @confirm="() => handlePullOff(record.id)">
                  <a>下架</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => myHandleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <salesPublishList-modal ref="modalForm" @ok="modalFormOk"></salesPublishList-modal>
    <salesPublishStock-modal ref="stockModal" @ok="modalFormOk"></salesPublishStock-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SalesPublishListModal from './modules/SalesPublishListModal'
  import SalesPublishStockModal from './modules/SalesPublishStockModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import JDate from '@/components/jeecg/JDate.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JMultiSelectTag from '@/components/dict/JMultiSelectTag'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import '@/assets/less/TableExpand.less'
  import {postAction} from '@/api/manage'

  export default {
    name: "SalesPublishListList",
    mixins:[JeecgListMixin],
    components: {
      JDictSelectTag,
      JDate,
      JMultiSelectTag,
      JSearchSelectTag,
      SalesPublishListModal,
      SalesPublishStockModal
    },
    data () {
      return {
        description: '商品发布台账管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'发布编号',
            align:"center",
            dataIndex: 'publishCode',
            scopedSlots: { customRender: 'FormNoLink' }
          },
          {
            title:'商品品类',
            align:"center",
            dataIndex: 'prodType_dictText'
          },
          {
            title:'商品发布名称',
            align:"center",
            dataIndex: 'publishProdName'
          },
          {
            title:'商品发布简介',
            align:"center",
            dataIndex: 'publishProdDescription'
          },
          {
            title:'所属门店',
            align:"center",
            dataIndex: 'storeId_dictText'
          },
          {
            title:'是否可配送',
            align:"center",
            dataIndex: 'publishIsdelivery_dictText'
          },
          {
            title:'发布渠道',
            align:"center",
            dataIndex: 'publishChannel_dictText'
          },
          {
            title:'商品在架状态',
            align:"center",
            dataIndex: 'publishSaleState_dictText'
          },
          {
            title:'发布状态',
            align:"center",
            dataIndex: 'publishState_dictText'
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'publishTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            // fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sales/salesPublishList/list",
          delete: "/sales/salesPublishList/delete",
          deleteBatch: "/sales/salesPublishList/deleteBatch",
          exportXlsUrl: "/sales/salesPublishList/exportXls",
          importExcelUrl: "/sales/salesPublishList/importExcel",
          publishUrl: "/sales/salesPublishList/publishGoods",
          publishBatchUrl: "/sales/salesPublishList/publishBatchGoods",
          removeOnlineUrl: "/sales/salesPublishList/removeGoods",
          putOnSaleUrl: "/sales/salesPublishList/putOnGoods",
          pullOffUrl: "/sales/salesPublishList/putOffGoods"
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      myHandleDetail(record){
        this.$refs.modalForm.action = 'detail';
        this.handleDetail(record)
      },
      myHandleAdd(){
        this.$refs.modalForm.action = 'add';
        this.handleAdd()
      },
      myHandleEdit(record){
        this.$refs.modalForm.action = 'edit';
        this.handleEdit(record)
      },
      publishProd(record){
        var that = this;
        postAction(this.url.publishUrl, {id:record.id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.loadData();
            that.onClearSelected();
          }else{
            that.$message.error(res.message)
          }
        })
      },
      myHandleDelete(id){
        postAction(this.url.removeOnlineUrl, {id:id}).then((res) => {
          if (res.success) {
            this.handleDelete(record)
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        })
      },
      handleBatchPublish(){
        var ids = "";
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }
        var that = this;
        this.$confirm({
          title: "确认发布",
          content: "是否批量发布选中数据?",
          onOk: function () {
            that.loading = true;
            postAction(that.url.publishBatchUrl, {ids: ids}).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.loading = false;
            });
          }
        });


      },
      copyAndEdit(record){
        this.$refs.modalForm.action = 'add';
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
        let copyRecord  = Object.assign({}, record)
        let removeProps = [
          'id','createBy','createTime','publishCode','publishCode','publishState','publishState_dictText','publishTime','updateBy','updateTime'
        ]
        removeProps.forEach(prop => {
          delete copyRecord[prop]
        })
        this.$refs.modalForm.copy(copyRecord);
      },
      handlePutOnSale(id){
        postAction(this.url.putOnSaleUrl, {id:id}).then((res) => {
          if (res.success) {
            this.searchQuery()
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        })
      },
      handlePullOff(id){
        postAction(this.url.pullOffUrl, {id:id}).then((res) => {
          if (res.success) {
            this.searchQuery()
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        })
      },
      handleUpdateStock(record){
        this.$refs.stockModal.edit(record)
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>